import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Link,
} from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Container,
  Avatar,
  CssBaseline,
  ThemeProvider,
  createTheme,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Collapse,
  Box,
  Tooltip,
  Divider,
  Button
} from "@mui/material";

import {
  Business,
  Store,
  People,
  Security,
  BarChart,
  PeopleOutline,
  PeopleTwoTone,
  Diversity3,
  PinDrop,
  Source,
  AccountBalance,
  LocalShipping,
  AdminPanelSettings,
  Article,
} from "@mui/icons-material"; import { Settings } from "@mui/icons-material";
// import { Drawer, List, ListItem, ListItemText, AppBar, Toolbar, IconButton, Collapse, Typography, Container, Tooltip } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";

//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';

//---------------- Auth---------------- 
import { AuthProvider, useAuth } from "./AuthContext";

//---------------- Sidebar + Logout---------------- 
import Sidebar from "./Sidebar";
import Logout from "./Logout";

//SessionTimeOut
//import SessionTimeout from "./SessionTimeout";

// ------------Company------------------ 
import CompanyEdit from "./components/pages/Company/Edit";
// ------------Home---------------------
import Home from "./components/pages/Home";

// ------------Role---------------------
import RoleIndex from "./components/pages/Role/Index";
import RoleDetail from "./components/pages/Role/Detail";

//-------------User---------------------
import UserIndex from "./components/pages/User/Index";
import UserCreate from "./components/pages/User/Create";
import UserEdit from "./components/pages/User/Edit";
import UserDetail from "./components/pages/User/Detail";
import PasswordChange from "./components/pages/User/PasswordChange";

//------------Employee-------------------
import EmployeeCreate from "./components/pages/Employee/Create";
import EmployeeEdit from "./components/pages/Employee/Edit";
import EmployeeIndex from "./components/pages/Employee/Index";

//------------Branch---------------------
import BranchCreate from "./components/pages/Branch/Create";
import BranchEdit from "./components/pages/Branch/Edit";
import BranchIndex from "./components/pages/Branch/Index";
//------------Attandance-----------------
import AttendanceIndex from "./components/pages/Attendance/Index";
import AttendanceEdit from "./components/pages/Attendance/Edit";
//------------PayRoll--------------------
import PayRollIndex from "./components/pages/PayRoll/Index";
//-----------Shift-----------------------
import ShiftIndex from "./components/pages/Shifts/Index";
//-----------Department------------------
import DepartmentIndex from "./components/pages/Department/Index";
//-----------Designation-----------------
import DesignationIndex from "./components/pages/Designation/Index";
//---------------- Bata Settings----------------
import BataSettingsIndex from "./components/pages/BataSettings/Index";
import BataSettingsCreate from "./components/pages/BataSettings/Create";
//---------------- Salary Advance----------------
import SalaryAdvanceIndex from "./components/pages/SalaryAdvance/Index";
import SalaryAdvanceCreate from "./components/pages/SalaryAdvance/Create";
import SalaryAdvanceDetails from "./components/pages/SalaryAdvance/Details";
import SalaryAdvanceEdit from "./components/pages/SalaryAdvance/Edit";
// Driver's Bata
import DriverBataIndex from "./components/pages/DriversBata/Index";
//---------------- Styles---------------- 
import './stylesheet.css';
import './toggleSwitch.css';
import './App.css';
import './ButtonStyle.scss';
import './loding.scss';

// ---------------- Theme ---------------- //
const theme = createTheme({
  palette: {
    primary: { main: "#0F353F" },
    secondary: { main: "#0F353F" },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: "8px",
          textTransform: "none",
        },
      },
    },
  },
});

//const Sidebar = ({ open, roleName }) => {
// ---------------- Layout ---------------- //
const Layout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [hoverOpen, setHoverOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const { companyName, roleName, username } = useAuth();

  const [dropdownOpen, setDropdownOpen] = useState(false);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        {/* Header */}
        <AppBar position="fixed" color="primary" sx={{ zIndex: (t) => t.zIndex.drawer + 1 }} style={{ height: '55px' }}>
          <Toolbar>
            <IconButton color="inherit" onClick={() => setSidebarOpen(!sidebarOpen)}>
              <MenuIcon />
            </IconButton>

            <Typography
              variant="h6"
              sx={{ flexGrow: 1, ml: 2, fontWeight: "bold", textTransform: "uppercase" }}
            >
              <Link to="/Home" style={{ textDecoration: "none", color: "inherit" }}>
                <span style={{ fontFamily: 'Verdana, sans-serif', fontSize: '14px' }}>{companyName}</span>
              </Link>
            </Typography>

            <div className="white-icon" style={{ display: 'flex', alignItems: 'center', marginTop: '-5px', }} >
              <div style={{ display: 'flex', alignItems: 'center', }} >
                <Logout />
              </div>
            </div>
          </Toolbar>
        </AppBar>

        {/* Sidebar */}
        {username !== "Counter" && (
          <Box
            onMouseEnter={() => setHoverOpen(true)}
            onMouseLeave={() => setHoverOpen(false)}
          >
            <Sidebar open={sidebarOpen || hoverOpen} roleName={roleName} />
          </Box>
        )}

        {/* Content */}
        <Box
          sx={{
            ml: sidebarOpen || hoverOpen ? "240px" : "60px",
            pt: 10,
            transition: "0.3s",
          }}
        >
          <Container maxWidth="xl">
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/Home" exact component={Home} />

              {/* Role */}
              <Route path="/RoleIndex" component={RoleIndex} />
              <Route path="/RoleDetail/:id" component={RoleDetail} />

              {/* User */}
              <Route path="/UserIndex" component={UserIndex} />
              <Route path="/UserCreate" component={UserCreate} />
              <Route path="/UserEdit/:id" component={UserEdit} />
              <Route path="/UserDetail/:id" component={UserDetail} />
              <Route path="/PasswordChange" component={PasswordChange} />

              {/* Employee */}
              <Route path="/EmployeeCreate" component={EmployeeCreate} />
              <Route path="/EmployeeEdit/:id" component={EmployeeEdit} />
              <Route path="/EmployeeIndex" component={EmployeeIndex} />

              {/* Home */}
              {/* Branch */}
              <Route path="/BranchIndex" component={BranchIndex} />
              <Route path="/BranchCreate" component={BranchCreate} />
              <Route path="/BranchEdit/:id" component={BranchEdit} />

              {/* Payment And Receipt */}
              <Route path="/CompanyEdit" component={CompanyEdit} />

              {/* Attendance */}
              <Route path="/AttendanceIndex" component={AttendanceIndex} />
              <Route path="/AttendanceEdit/:id" component={AttendanceEdit} />
              {/* Pay Roll */}
              <Route path="/PayRollIndex" component={PayRollIndex} />
              {/* Shift */}
              <Route path="/ShiftIndex" component={ShiftIndex} />
              {/* Department */}
              <Route path="/DepartmentIndex" component={DepartmentIndex} />
              {/* Designation */}
              <Route path="/DesignationIndex" component={DesignationIndex} />
              {/* Bata Settings */}
              <Route path="/BataSettingsIndex" component={BataSettingsIndex} />
              <Route path="/BataSettingsCreate" component={BataSettingsCreate} />
              {/* Salary Advance */}
              <Route path="/SalaryAdvanceIndex" component={SalaryAdvanceIndex} />
              <Route path="/SalaryAdvanceCreate" component={SalaryAdvanceCreate} />
              <Route path="/SalaryAdvanceDetails/:id" component={SalaryAdvanceDetails} />
              <Route path="/SalaryAdvanceEdit/:id" component={SalaryAdvanceEdit} />
              {/* Driver's Bata */}
              <Route path="/DriverBataIndex" component={DriverBataIndex} />
              {/* Add more routes as needed */}

            </Switch>
          </Container>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

// ---------------- Root ---------------- //
const App = () => {
  return (
    <Router>
      <AuthProvider>
        <Layout />
      </AuthProvider>
    </Router>
  );
};
export default App;
